import { removeEmptyEntries } from '../../../../utils';
import tracker from '../../../../utils/reports/TrackingService';
import { EVENTS } from './constants';

export const reportSingleReviewMixpanelEvent = (reviewer) => {
    tracker.sendMixPanelEvent({
        eventName: EVENTS.Mixpanel,
        eventPayload: removeEmptyEntries({
            ComponentName: 'single-review',
            Reviewer: reviewer,
        }),
    });
};
